import ledgers from "@/services/ledgers";
import mixin from '@/mixins/controls.js';

export default {
    mixins: [mixin],
    methods: {
        async preloadData() {
            this.setDefaultLanguage(); 

            if (!this.$store.state.ledgers.types ||
                this.$store.state.ledgers.types.length == 0) {
                try {
                    await this.getSLCodes();
                } catch(error) {
                    console.error("Error while retrieving SL codes: ", error);
                }
            }
            this.preloadImages();
            this.preloadVideo();
        },
        setDefaultLanguage() {
            const preferredLanguage = localStorage.getItem('preferredLanguage');
            if (!preferredLanguage) {
                this.$store.commit('setLanguage', 'en');
            }
        },
        getSLCodes() {
            return new Promise((resolve, reject) => {
                ledgers.getSLCodes()
                    .then((response) => {
                        const data = response.data.data;
                        this.$store.commit('appendToSL', data);
                        resolve(); 
                    })
                    .catch((error) => {
                        reject(error); 
                    });
            });
        },
        preloadImages() {
            const images = Object.values(this.images).map(image => `${process.env.VUE_APP_MEDIA_URL}/${image}`);
            
            images.forEach((url) => {
                const img = new Image();
                img.src = url;
            });
        },
        preloadVideo() {
            const videoUrl = `${process.env.VUE_APP_MEDIA_URL}/videos/papsi_video.mp4`;
            const video = document.createElement('video');
            video.src = videoUrl;
            video.preload = 'auto';
        }
    }
}